/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Skip_To_Main_ContentInputs */

const en_skip_to_main_content = /** @type {(inputs: Skip_To_Main_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skip to main content`)
};

const de_skip_to_main_content = /** @type {(inputs: Skip_To_Main_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zum Hauptinhalt springen`)
};

const fr_skip_to_main_content = /** @type {(inputs: Skip_To_Main_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aller au contenu principal`)
};

const es_skip_to_main_content = /** @type {(inputs: Skip_To_Main_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saltar al contenido principal`)
};

const it_skip_to_main_content = /** @type {(inputs: Skip_To_Main_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vai al contenuto principale`)
};

const nl_skip_to_main_content = /** @type {(inputs: Skip_To_Main_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ga naar hoofdinhoud`)
};

const pl_skip_to_main_content = /** @type {(inputs: Skip_To_Main_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przejdz do glownej tresci`)
};

const fi_skip_to_main_content = /** @type {(inputs: Skip_To_Main_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siirry paeasisaltoon`)
};

const da_skip_to_main_content = /** @type {(inputs: Skip_To_Main_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spring til hovedindhold`)
};

const sv_skip_to_main_content = /** @type {(inputs: Skip_To_Main_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoppa till huvudinnehaallt`)
};

/**
* | output |
* | --- |
* | "Skip to main content" |
*
* @param {Skip_To_Main_ContentInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const skip_to_main_content = /** @type {((inputs?: Skip_To_Main_ContentInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Skip_To_Main_ContentInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_skip_to_main_content(inputs)
	if (locale === "fr") return fr_skip_to_main_content(inputs)
	if (locale === "es") return es_skip_to_main_content(inputs)
	if (locale === "it") return it_skip_to_main_content(inputs)
	if (locale === "nl") return nl_skip_to_main_content(inputs)
	if (locale === "pl") return pl_skip_to_main_content(inputs)
	if (locale === "fi") return fi_skip_to_main_content(inputs)
	if (locale === "da") return da_skip_to_main_content(inputs)
	if (locale === "sv") return sv_skip_to_main_content(inputs)
	return en_skip_to_main_content(inputs)
});